module.exports = __webpack_public_path__ + "img/depmap_svg_V160.b2f5ff58.svg";